import * as types from './action-types';
import { AgreementDraftService } from 'frilans-finans';

export function setEntity (terms) {
  return {
    type: types.SET_ENTITY,
    payload: terms
  };
}

// Thunks

export function fetch (language) {
  return (dispatch) => {
    AgreementDraftService.generalTerms(language)
    .then((entity) => {
      dispatch(setEntity(entity));
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/general-terms/index.js
 **/